import React, { useEffect, useState } from 'react';
import { TabsFilter } from './TabsFilter/TabsFilter';
import styles from './LastDisbursementDateCloseOrExpired.module.scss';
import { EarlyWarningsFilters } from '../EarlyWarningsFilters/EarlyWarningsFilters';
import { LastDisbursementTable } from './Table/Table';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectsSimpleTableIndicator } from '../../../redux/actions/indicatorProjects';
import { LAST_DISBURSEMENT_DATE_CLOSE_OR_EXPIRED } from '../../../services/sessionFiltersIndicatorDetailHelper';
import { FilterConfigValues, IconCode, TabFilterOption } from '../../../models/EarlyWarnings';
import { useEarlyWarningsFilters } from '../../../hooks/useEarlyWarningsFilters';
import { showEarlyWarningModule } from './Util';
import { createFilterConfigComponent } from '../EarlyWarningsFilters/Util';
import { handleLoading } from '../../utils';
import FilterIndicators from '../../../models/FilterIndicators';
import { AppMenuTabs } from '../../MenuTabs/userTabsInterface';
import { setIndicatorResponse, setLoading } from '../../../redux/actions/dataTable';
import { getNewFilteredIndicators } from '../../../api/indicatorApi';
import { translateMultipleText } from '../../../services/stringUtil';
import { emptyProjects } from '../../Portfolio/PortfolioUtil';
import { useTranslation } from 'react-i18next';
import { ProjectProductTypes } from '../../../models/ProjectProductTypes';
import { resetIndicatorDetailFilter } from '../../../redux/actions/indicatorDetailFilters';
import { updateCreatingOrEditing } from '../../../redux/actions/menuTabs';
import { processIndicators } from '../../Portfolio/indicatorHelper';
import { arrayMove } from 'react-sortable-hoc';
import { addIndicators } from '../../../redux/actions/indicators';
import { setCurrentIndicator } from '../../../redux/actions/currentIndicator';
import { ProjectsListSkeleton } from '../../LoadersSkeletons/ProjectsListSkeleton/ProjectsListSkeleton';

const filterConfigValues: FilterConfigValues[] = [
  { id: 0, filterIcon: IconCode.GREEN, filterLabel: 'within_the_period_for_justification_120_days' },
  { id: 1, filterIcon: IconCode.YELLOW, filterLabel: 'with_date_for_last_disbursement_expired_by_less_than_1_year' },
  { id: 2, filterIcon: IconCode.RED, filterLabel: 'with_date_for_last_disbursement_expired_by_1_year_or_more' },
];
const filterConfigComponent: TabFilterOption[] = createFilterConfigComponent(filterConfigValues);

const defaultSessionFilterObject = {
  selectedTab: 0,
  filterConfigState: filterConfigComponent,
  changeProjectType: true,
};

export const LastDisbursementDateCloseOrExpired = () => {
  const { currentIndicator } = useSelector<any, any>(state => state);
  const { projectTypeFilterOnDetail } = useSelector<any, any>(state => state.indicatorDetailFilter);
  const { filterConfigState, handleEarlyWarningsFilter, handleProjectsQuantities, selectedTab, setSelectedTab } =
    useEarlyWarningsFilters({
      sessionKey: LAST_DISBURSEMENT_DATE_CLOSE_OR_EXPIRED,
      defaultSessionFilterObject,
      projectTypeFilterOnDetail,
    });
  const dispatch = useDispatch();
  const { container, tabsContainer, filtersEarlyWarningsContainer, tableContainer } = styles;
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const { t } = useTranslation();

  // Filter
  const filterIndicators = useSelector<any, FilterIndicators>(state => state.filterIndicators);
  const stateProjectProductTypes = useSelector<any, FilterIndicators>(
    state => state.indicatorPayload.payload.projectProductTypes,
  );
  const menuTabs = useSelector<any, AppMenuTabs>(state => state.menuTabs);
  const portfolioSelectedTab = menuTabs.portfolioSelectedTab;
  const creatingOrEditing = menuTabs.creatingOrEditing;
  const [isLoading, setIsLoading] = React.useState(false);
  const [totalProjects, setTotalProjects] = React.useState(false);

  const projectTypeFilterChange = {
    ...filterIndicators,
    common: { ...filterIndicators.common, projectTypeFilters: stateProjectProductTypes },
    projectTypeFilters: stateProjectProductTypes,
  };

  const handleCommonFilterChange = async () => {
    dispatch(setLoading(true));
    setIsLoading(true);

    try {
      const indicatorsToProcess = await getNewFilteredIndicators(
        {},
        { projectProductTypes: stateProjectProductTypes },
        {
          ...projectTypeFilterChange.common,
        },
      );
      dispatch(setIndicatorResponse(indicatorsToProcess));
      startProcessIndicators(
        indicatorsToProcess,
        translateMultipleText(` ${' '} ${portfolioSelectedTab.title}`, t),
        filterIndicators.common.projectTypeFilters,
      );
      setTotalProjects(emptyProjects(indicatorsToProcess.totalProjects));
    } catch (err) {
      console.error(err, 'Error fetching data from indicators');
    } finally {
      dispatch(setLoading(false));
      setIsLoading(false);
    }
  };

  const startProcessIndicators = (inds, titleFromTab, projectTypeFilter = [ProjectProductTypes.Loan]) => {
    const result = processIndicators(inds, {
      titleFromTab,
      projectTypeFilter,
    });
    const elementSummary: any = result.find(elem => elem.id === 15);
    const indexSummary: number = result.indexOf(elementSummary);
    const sendEndSummary = arrayMove(result, indexSummary, result.length);

    dispatch(addIndicators(sendEndSummary));
    dispatch(
      setCurrentIndicator(
        sendEndSummary?.find(data => data.indicatorKey === 'PROJECTS_LAST_DISBURSEMENT_DATE_CLOSE_12MONTHS_OR_EXPIRED'),
      ),
    );
    setIsLoading(false);
  };

  // const tabId0OrCreatingEditing = (menuTabs, creatingOrEditing) =>
  //   menuTabs.portfolioSelectedTab.tabId === 0 || creatingOrEditing;

  useEffect(() => {
    getFilteredSimpleIndicators(
      dispatch,
      currentIndicator.id,
      currentIndicator.indicatorKey,
      setLoadingData,
      // projectTypeFilterChange,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndicator.id, dispatch, projectTypeFilterOnDetail]);

  useEffect(() => {
    if (!sessionStorage.getItem(LAST_DISBURSEMENT_DATE_CLOSE_OR_EXPIRED)) {
      sessionStorage.setItem(LAST_DISBURSEMENT_DATE_CLOSE_OR_EXPIRED, JSON.stringify(defaultSessionFilterObject));
    }
  }, []);

  useEffect(() => {
    if (
      filterIndicators.common.coReponsibleDivisions.length > 0 ||
      filterIndicators.common.countryId.length > 0 ||
      filterIndicators.common.divisionId.length > 0 ||
      filterIndicators.common.interestIssues.length > 0 ||
      filterIndicators.common.participantDivisions.length > 0 ||
      filterIndicators.common.regionId.length > 0 ||
      filterIndicators.common.sectors.length > 0 ||
      filterIndicators.common.teamLeaders.length > 0
    )
      handleCommonFilterChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  useEffect(() => {
    dispatch(resetIndicatorDetailFilter());
    if (
      !menuTabs.firstLoad &&
      // tabId0OrCreatingEditing(menuTabs, creatingOrEditing) &&
      filterIndicators.common.coReponsibleDivisions.length === 0 &&
      filterIndicators.common.countryId.length === 0 &&
      filterIndicators.common.divisionId.length === 0 &&
      filterIndicators.common.interestIssues.length === 0 &&
      filterIndicators.common.participantDivisions.length === 0 &&
      filterIndicators.common.regionId.length === 0 &&
      filterIndicators.common.sectors.length === 0 &&
      filterIndicators.common.teamLeaders.length === 0
    ) {
      handleCommonFilterChange();

      if (creatingOrEditing) {
        dispatch(updateCreatingOrEditing(false));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  const handleFilterApplied = filter => {
    setSelectedTab(filter);
  };

  return (
    <>
      {!isLoading ? (
        <div className={container}>
          <div className={tabsContainer}>
            <TabsFilter filterBy={selectedTab} handleFilterApplied={handleFilterApplied} />
          </div>
          {showEarlyWarningModule(projectTypeFilterOnDetail, selectedTab) && (
            <div className={filtersEarlyWarningsContainer}>
              <EarlyWarningsFilters filterSet={filterConfigState} handleFilter={handleEarlyWarningsFilter} />
            </div>
          )}
          <div className={tableContainer}>
            <LastDisbursementTable
              selectedTab={selectedTab}
              earlyWarningsTab={[
                filterConfigState[0].selected,
                filterConfigState[1].selected,
                filterConfigState[2].selected,
              ]}
              projectsQuantities={handleProjectsQuantities}
              loading={loadingData}
            />
          </div>
        </div>
      ) : (
        <ProjectsListSkeleton />
      )}
    </>
  );
};

const getFilteredSimpleIndicators = (
  d,
  currentIndicatorId,
  currentIndicatorKey,
  setLoading,
  projectTypeFilterChange?,
) => {
  return handleLoading(
    () => d(getProjectsSimpleTableIndicator(currentIndicatorId, currentIndicatorKey, projectTypeFilterChange)),
    setLoading,
  );
};
